import { Base } from '@studiometa/js-toolkit';
import { addStyle, damp, transform, nextTick } from '@studiometa/js-toolkit/utils';

/**
 *
 */
export default class Navbar extends Base {
  static config = {
    name: 'Navbar',
  };

  y = 0;
  dampedY = 0;
  dampFactor = 0.7;
  dampFactorMethod = 0.1;
  positionY = 0;

  /**
   * targetY
   * @returns {number}
   */
  get targetY() {
    return (this.$el.offsetHeight + this.additionnalHeight) * -1;
  }

  /**
   * setPositionY
   */
  async setPositionY() {
    const sentinel = document.createElement('div');
    addStyle(sentinel, {
      position: 'relative',
      display: 'block',
      height: '1px',
      padding: '0',
      marginBottom: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      borderWidth: '0',
    });
    this.$el.parentNode.insertBefore(sentinel, this.$el);
    await nextTick();
    this.positionY = sentinel.offsetTop;
    sentinel.remove();
  }

  /**
   * Mounted
   */
  mounted() {
    this.setPositionY();
    this.addHeaderAnnoucementHeight();
  }

  /**
   * Resized
   */
  resized() {
    this.setPositionY();
    this.addHeaderAnnoucementHeight();
  }

  /**
   *
   */
  addHeaderAnnoucementHeight() {
    const headerAnnoucement = document.querySelector('.shopify-section-group-preheader-group');
    this.additionnalHeight = 0;
    if (headerAnnoucement) {
      this.additionnalHeight = headerAnnoucement.getBoundingClientRect().height;
    }
  }

  /**
   *
   */
  ticked() {
    if (this.y !== this.dampedY) {
      this.dampedY = damp(this.y, this.dampedY, this.dampFactor);
      transform(this.$el, {
        y: this.dampedY,
      });
    }
    if (this.dampedY === this.y) {
      this.$services.disable('raf');
    }
  }

  /**
   *
   */
  show() {
    if (this.dampedY === 0) {
      return;
    }
    this.dampFactor = this.dampFactorMethod;
    this.y = 0;
    this.$services.enable('raf');
  }

  /**
   *
   */
  hide() {
    if (this.dampedY === this.targetY) {
      return;
    }
    this.dampFactor = this.dampFactorMethod;
    this.y = this.targetY;
    this.$services.enable('raf');
  }
}
